import {
  DialogContent,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';
import { type FC, useCallback } from 'react';

import { useDeleteCamera } from '../../api/index.js';
import { type Camera } from '../../models/index.js';
import { Events, track } from '../../utils/index.js';
import DeleteDialog from '../DeleteDialog.js';

interface CameraDeleteProps {
  open: boolean;
  onClose: () => void;
  camera?: Camera;
  refetch: () => void;
}
const CameraDelete: FC<CameraDeleteProps> = ({
  open,
  onClose,
  camera,
  refetch,
}) => {
  const deleteMutation = useDeleteCamera();

  const onSubmit = useCallback(async () => {
    if (camera?.id) {
      return deleteMutation.mutateAsync(camera.id);
    }
  }, [camera, deleteMutation]);

  const trackFn = useCallback(() => {
    track(Events.CameraDelete, {
      cameraId: camera?.id,
      patientId: camera?.patientId,
    });
  }, [camera]);

  return (
    <DeleteDialog
      open={open}
      name={'camera'}
      onClose={onClose}
      onSubmit={onSubmit}
      refetch={refetch}
      trackFn={trackFn}
    >
      {camera ? (
        <DialogContent>
          {camera.patient ? <Typography>Deleting camera for patient: {`${camera?.patient?.firstName} ${camera?.patient?.lastName}`}</Typography> : null}
          <List dense>
            <ListItem>
              <ListItemText primary={`Name: ${camera.name}`} />
            </ListItem>
            <ListItem>
              <ListItemText primary={`IP Address: ${camera.ipAddress}`} />
            </ListItem>
            <ListItem>
              <ListItemText primary={`Port: ${camera.port}`} />
            </ListItem>
          </List>
        </DialogContent>
      ) : null}
    </DeleteDialog>
  );
};

export default CameraDelete;
